<template>
	<div class="status">
		<h2 class="status__text">성분 등록 현황</h2>
		<div class="status__cards">
			<div
				class="status__card"
				v-for="trend in trends"
				:key="trend.label"
			>
				<h3>{{ trend.label }}</h3>
				<div class="status__value">{{ formatNumber(trend.value) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			factorCount: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {};
		},
		computed: {
			trends() {
				const productTotal = this.factorCount?.productTotal || 0;
				const factorMappingProduct =
					this.factorCount?.factorMappingProduct || 0;
				const productFactorOpen =
					this.factorCount?.productFactorOpen || 0;

				return [
					{ label: '총 제품', value: productTotal },
					{ label: '총 매칭', value: factorMappingProduct },
					{ label: '전시 중', value: productFactorOpen },
				];
			},
		},
		methods: {
			formatNumber(value) {
				return value.toLocaleString();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.status {
		text-align: center;
		padding: 20px;
		border: 1px solid #dfe6ee;
		margin-top: 20px;
		border-radius: 10px;
		&__text {
			font-size: 18px;
			margin: 0 0 20px 0;
			font-weight: bold;
		}
	}

	.status__cards {
		display: flex;
		justify-content: space-around;
		gap: 20px;
	}

	.status__card {
		padding: 20px;
		border-radius: 10px;
		background-color: #f0f4f8;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		text-align: center;
		width: 150px;
		h3 {
			margin: 0;
			font-size: 16px;
			font-weight: bold;
			color: #333;
		}

		.status__value {
			font-size: 24px;
			font-weight: bold;
			margin: 10px 0;
			color: #42a5f5;
		}
	}
</style>
